
<select id="{{getFieldName()}}" [formControl]="field" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && field && field.errors }">
  <option *ngFor="let record of list" [ngValue]=getValue(record)>{{getText(record)}}</option>
</select>

<app-form-error [field]="field" [submitted]="submitted"></app-form-error>